if (!customElements.get('order-configurator')) {
  // Choosing a colour swaps the whole product section in place, recreating the
  // element, so the wizard position lives at module scope: it survives the swap
  // but resets to step 1 on a real page load (refresh or another product).
  let wizardStep = 1;

  customElements.define(
    'order-configurator',
    class OrderConfigurator extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('.order-configurator__step'));
        if (!this.steps.length) return;

        // The branding popup counts as the final step of the journey but has
        // no inline panel, so the declared total can exceed the DOM step count.
        this.totalSteps = parseInt(this.dataset.totalSteps, 10) || this.steps.length;

        this.addEventListener('click', this.onClick.bind(this));

        this.setupStickyBar();
        this.showStep(wizardStep);
      }

      setupStickyBar() {
        this.stickyBar = this.querySelector('[data-order-sticky-bar]');
        if (!this.stickyBar) return;

        document.body.appendChild(this.stickyBar);
        this.stickyBar.addEventListener('click', this.onClick.bind(this));

        this.stickyBarObserver = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.stickyBar.classList.toggle('order-sticky-bar--visible', scrolledPast);
        });
        this.stickyBarObserver.observe(this);
      }

    
      disconnectedCallback() {
        this.stickyBarObserver?.disconnect();
        this.stickyBar?.remove();
      }

      onClick(event) {
        if (event.target.closest('[data-step-next]')) {
          this.showStep(this.currentStep + 1);
        } else if (event.target.closest('[data-step-back]')) {
          this.showStep(this.currentStep - 1);
        } else if (event.target.closest('[data-sticky-cta]')) {
       
          if (this.currentStep < this.steps.length) {
            this.showStep(this.currentStep + 1);
            this.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            this.querySelector('.multi-size__submit')?.click();
          }
        }
      }

      showStep(step) {
        step = Math.min(Math.max(step, 1), this.steps.length);
        this.currentStep = step;
        this.renderProgress(step);
        this.steps.forEach((element, index) => element.classList.toggle('hidden', index + 1 !== step));
        wizardStep = step;

        const cta = this.stickyBar?.querySelector('[data-sticky-cta]');
        if (cta) {
          cta.textContent = step < this.steps.length ? cta.dataset.labelAdvance : cta.dataset.labelSubmit;
        }
      }

      renderProgress(step) {
        const stepLabel = this.querySelector('[data-step-current]');
        if (stepLabel) stepLabel.textContent = step;

        const fill = this.querySelector('[data-progress-fill]');
        // Fill shows completed steps plus a small head start, per the design.
        if (fill) fill.style.width = `${Math.min(((step - 1) / this.totalSteps) * 100 + 5, 100)}%`;
      }

      
      enterVirtualStep() {
        this.renderProgress(this.totalSteps);
      }

      exitVirtualStep() {
        this.renderProgress(this.currentStep);
      }
    }
  );
}
